import CryptoJS from 'crypto-js'
export const decrypt = (encryptData) => {
	var decrypt = CryptoJS.AES.decrypt(encryptData, CryptoJS.enc.Utf8.parse('cce1d5a8d58249048623eb26b8b0ea53'), {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	})
	return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}
